const DEV_ENV_KEYS = ['devel', 'mock', 'dev', 'staging'];
const keyIsAbsent = (envKey) => !window.origin.includes(envKey);
const isLive = () => {
    try {
        return DEV_ENV_KEYS.every(keyIsAbsent);
    }
    catch (error) {
        console.log('ERROR:', error);
        return false;
    }
};
const collectError = (error, info) => {
    if (process.env.NODE_ENV === 'development' || !isLive()) {
        console.log('ERROR:', error, info);
        return;
    }
    window.newrelic?.noticeError(error, info);
};
export default collectError;
